import { useFirestore } from '../../hooks/useFirestore'
// import { projectFirestore } from "../../firebase/config"

// styles
import styles from './Home.module.css'

export default function TransactionList({ transactions }) {
  
  const { deleteDocument, updateDocument } = useFirestore('transactions')
  //const ref = projectFirestore.collection(collection)

  //console.log("TL")
  // deleteDocument(transaction.id)
  const delDoc = (transaction) => {
    if (transaction.rl1) {
      updateDocument(transaction.id, { rl2: true })
      // projectFirestore.collection('transactions').doc(transaction.id)
      //   .update({rl2: true})
      //console.log("TLdelrl2", transaction.rl1, transaction.rl2)
    }
    else {
      deleteDocument(transaction.id)
    }
  }

  const toggleDoc = (transaction) => {
    // e.stopPropagation()
    if (transaction.rl1) {
      updateDocument(transaction.id, { rl1: false })
      // projectFirestore.collection('transactions').doc(transaction.id)
      //   .update({rl2: true})
      //console.log("TLdelrl2", transaction.rl1, transaction.rl2)
    }
    else {
      updateDocument(transaction.id, { rl1: true })
      //deleteDocument(transaction.id)
    }
    // if (transaction.rl2) {
    //   updateDocument(transaction.id, { rl1: true })
    // }
  }

  return (
    <ul className={styles.transactions}
    >
      {transactions.map((transaction) => (
        !transaction.rl2 &&
        <li key={transaction.id}
          style={{
            borderLeft: transaction.rl1 ? "25px solid #bbb" :
              "25px solid #1f9751"
          }}
        // onClick={(e) => toggleDoc(transaction)}
        >
          <button
            className={styles.btn3}
            onClick={() => toggleDoc(transaction)}
          >reload
          </button>

          <p className={styles.name}>{transaction.name}</p>
          {/* <p>--rl1: {String(transaction.rl1)}--rl2: {String(transaction.rl2)}</p> */}
          <button className={styles.btn2} onClick={() => delDoc(transaction)}>x</button>
        </li >

      ))
      }
    </ul >
  )
}